import React from 'react';
import { Box } from '@mui/material';
import ServicesSection from '../components/LandingPage/ServicesSection';
import ServicesTitle from '../components/ServicesPage/ServicesTitle';
import ServiceHero from '../components/ServicesPage/ServiceHero';
import servicePic1 from '../Media/image-1.png';
import servicePic2 from '../Media/image-2.png';
import servicePic3 from '../Media/image-3.png';
import servicePic4 from '../Media/image-4.png';
import servicePic5 from '../Media/image-5.png';
import servicePic6 from '../Media/image-6.png';
import servicePic7 from '../Media/image-7.png';
import servicePic8 from '../Media/image-8.png';
import servicePic9 from '../Media/image-9.png';

const ServicesPage = () => {
  const services = [
    {
      title: "Residential Mortgages!",
      description: "Begin your homeownership journey with our experienced team. We have trusted mortgage solutions designed to support first-time buyers and sellers, as well as experienced homeowners.",
      image: servicePic1,
      features: [
        { title: "Personalized Mortgage Plans for Every Buyer", description: "Tailored mortgage options that reflect your unique goals, lifestyle, and financial situation." },
        { title: "Guidance from Application to Approval", description: "Experienced professionals assist you at every step for a smooth and stress-free process." },
        { title: "Low Rates, Flexible Terms", description: "Access competitive interest rates and flexible terms to reduce costs." }
      ]
    },
    {
      title: "Self Employed Mortgage!",
      description: "Access flexible mortgage solutions made for entrepreneurs, freelancers, and small business owners with non-traditional income.",
      image: servicePic2,
      features: [
        { title: "Expert Support Through the Entire Process", description: "Guidance tailored for the self-employed from start to finish." },
        { title: "Flexible Documentation Options", description: "Use bank statements, business records, or alternative proof of income." },
        { title: "Customized Repayment Options", description: "Adaptable payment plans aligned with your cash flow and vision." }
      ],
      isReversed: true
    },
    {
      title: "Construction Mortgages!",
      description: "Bring your dream home to life with financial support that grows with your build.",
      image: servicePic3,
      features: [
        { title: "Stage-by-Stage Financing", description: "Draw funds as construction progresses to keep your project on track." },
        { title: "Tailored Loans for Builders", description: "Flexible options for custom homes or contracted builders." },
        { title: "Lock in Your Rate Early", description: "Secure a rate today, even if your project finishes later." }
      ]
    },
    {
      title: "New to Canada!",
      description: "Begin your new life in Canada with financing that helps you settle down and build your future confidently.",
      image: servicePic4,
      features: [
        { title: "No Long Credit History Needed", description: "Qualify using alternative credit sources or your home country’s history." },
        { title: "Programs for Permanent and Non-Permanent Residents", description: "Support whether on a temporary visa or permanent status." },
        { title: "Bilingual Mortgage Advisors", description: "Experts who understand your language, culture, and needs." }
      ],
      isReversed: true
    },
    {
      title: "Spousal Buyout and Divorce!",
      description: "Move forward with confidence and peace of mind using fair mortgage solutions during life’s major transitions.",
      image: servicePic5,
      features: [
        { title: "Keep the Family Home", description: "Buy out your partner’s share and maintain stability for your family." },
        { title: "Supportive Process During Difficult Times", description: "Specialists prioritize your privacy and emotional wellbeing." },
        { title: "Quick and Private Solutions", description: "Fast approvals while maintaining full confidentiality." }
      ]
    },
    {
      title: "Home Improvement Mortgage!",
      description: "Upgrade your living space with smart financing options that make renovation affordable and rewarding.",
      image: servicePic6,
      features: [
        { title: "Finance Major or Minor Renovations", description: "Get funds for anything from kitchens to full remodels." },
        { title: "Boost Property Value", description: "Improve your lifestyle and your home's resale value." },
        { title: "Blend with Your Current Mortgage", description: "Roll renovation costs into one manageable monthly payment." }
      ],
      isReversed: true
    },
    {
      title: "Investment Property!",
      description: "Grow your wealth with financing tailored for property investors and income-generating properties.",
      image: servicePic7,
      features: [
        { title: "Financing for Rental or Vacation Homes", description: "Mortgage options that fit your investment strategy." },
        { title: "Maximize Returns with Smart Lending", description: "Choose terms that support cash flow and tax planning." },
        { title: "Dedicated Investor Support", description: "Experts help assess risk, ROI, and growth opportunities." }
      ]
    },
    {
      title: "Refinancing & Debt Consolidation!",
      description: "Take control of your finances by refinancing your mortgage or consolidating high-interest debts.",
      image: servicePic8,
      features: [
        { title: "Lower Your Monthly Payments", description: "Reduce your mortgage rate or extend your term." },
        { title: "Access Your Home Equity", description: "Use home value for education, renovations, or emergencies." },
        { title: "Combine Multiple Debts into One", description: "Simplify with one affordable monthly payment." }
      ],
      isReversed: true
    },
    {
      title: "CHIP Reverse Mortgage!",
      description: "Enjoy retirement with comfort and freedom by unlocking the value of your home.",
      image: servicePic9,
      features: [
        { title: "No Monthly Payments Required", description: "Receive money without selling or monthly payments." },
        { title: "Stay in the Home You Love", description: "Access cash while remaining in your home." },
        { title: "Tax-Free Funds", description: "Withdraw money as needed, tax-free, and spend it freely." }
      ]
    }
  ];

  return (
    <Box>
      <ServicesTitle />
      <ServicesSection />
      {services.map((service, index) => (
        <ServiceHero key={index} {...service} />
      ))}
    </Box>
  );
};

export default ServicesPage;
